var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import EventCard from "../EventList/EventCard";
import { platformAwareRedirect } from "../../../data/helpers";
import Constants from "../../../data/constants";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
var LookupResults = function (_a) {
    var results = _a.results, isWidget = _a.isWidget, hasOneTotal = _a.hasOneTotal;
    var history = useWidgetHistory();
    useEffect(function () {
        if (results.length === 1 && hasOneTotal) {
            var evt = results[0].event;
            platformAwareRedirect(Constants.Routes.myDashboard
                .replace(":clientKey", evt.clientKey)
                .replace(":urlKey", evt.urlKey)
                .replace(":eventNumber", evt.eventNumber.toString())
                .replace("/:lookupId", ""), isWidget, history);
        }
    }, [results]);
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "event-card-results" }, { children: results.map(function (result, index) {
                var _a, _b;
                if (result.event === undefined) {
                    return null;
                }
                return (_jsx(EventCard, { event: result.event, isWidget: isWidget, isLoading: false, onClick: function (evt, e) {
                        e.preventDefault();
                        e.stopPropagation();
                        platformAwareRedirect(Constants.Routes.myDashboard
                            .replace(":clientKey", evt.clientKey)
                            .replace(":urlKey", evt.urlKey)
                            .replace(":eventNumber", evt.eventNumber.toString())
                            .replace("/:lookupId", ""), isWidget, history);
                    } }, (_b = (_a = result.event) === null || _a === void 0 ? void 0 : _a.eventNumber) !== null && _b !== void 0 ? _b : index));
            }) })) }));
};
export default LookupResults;
